import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=323e3c5f&scoped=true&"
import script from "./Remarks.vue?vue&type=script&lang=js&"
export * from "./Remarks.vue?vue&type=script&lang=js&"
import style0 from "./Remarks.vue?vue&type=style&index=0&id=323e3c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e3c5f",
  null
  
)

export default component.exports